function getLocalStorageKey($el) {
  return `is_${$el.data('section-name')}_closed`
}

function isClosed($el) {
  try {
    const key = getLocalStorageKey($el)
    return !!localStorage.getItem(key)
  } catch (error) {
    return false
  }
}

class Sidebar {
  constructor($root) {
    if (!$root.length) return
    this.$root = $root
    this.$user = $root.find('.sidebar__user')
    this.$userMenu = this.$root.find('.sidebar__user-menu')

    $root.on('click', '.sidebar__mobile-button', this.handleMobileMenu.bind(this))
    this.initSidebarCategory()

    $(document).click(e => {
      if (this.$user.get()[0].contains(e.target)) {
        this.$userMenu.toggleClass('is-open')
        this.$user.toggleClass('is-active')
      } else {
        this.$userMenu.removeClass('is-open')
        this.$user.removeClass('is-active')
      }
    })
  }

  handleMobileMenu() {
    if (this.$root.hasClass('is-open')) {
      $('body').removeClass('is-modal-open')
      this.$root.removeClass('is-open')
    } else {
      $('body').addClass('is-modal-open')
      this.$root.addClass('is-open')
    }
  }

  initSidebarCategory() {
    this.$root.find('.sidebar__category').each(function () {
      const $category = $(this)
      const $title = $category.find('.sidebar__category-title')

      if (isClosed($category)) {
        $category.addClass('is-closed')
      }

      $title.on('click', () => {
        const localStorageKey = getLocalStorageKey($category)
        if ($category.hasClass('is-closed')) {
          localStorage.removeItem(localStorageKey)
          $category.removeClass('is-closed')
        } else {
          localStorage.setItem(localStorageKey, true)
          $category.addClass('is-closed')
        }
      })
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  return new Sidebar($('.sidebar'))
})
